<style src="./ReportEmployeeEmissionsList.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="filterReport">
        <div class="row">
          <div class="col-lg-4">
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label class="col-sm-12">Colaborador</label>
                  <select class="form-control m-b" v-model="form.employee">
                    <option value>Todos</option>
                    <option
                      v-for="(item, idx) in employeeList"
                      :key="idx"
                      :value="item.userToken"
                    >
                      {{ item.fullName }}
                    </option>
                  </select>
                  {{ form.employee }}
                </div>
                <div class="col-sm-2">
                  <button
                    type="button"
                    class="btn btn-lg btn-success"
                    @click="goToReport"
                  >
                    Gerar Relatório
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        employee: '',
      },
      employeeList: [],
    };
  },
  mounted() {
    this.listEmployee();
  },
  methods: {
    async listEmployee() {
      const employeeListFull = await this.$store.dispatch(
        'EMPLOYEE/GetEmployeeList',
      );
      const employeeList = employeeListFull.map(item => ({
        id: item._id,
        fullName: item.fullName,
        userToken: item.userToken,
      }));
      this.employeeList = employeeList;
    },
    goToReport() {
      const userToken = this.form.employee;
      const dt = new Date();
      const year = dt.getFullYear();
      const month = (dt.getMonth() + 1).toString().padStart(2, '0');
      const day = dt
        .getDate()
        .toString()
        .padStart(2, '0');
      const date = `${year}-${month}-${day}`;

      this.$router.push({
        name: 'ReportEmployeeEmissions',
        params: { userToken, date },
      });
    },
  },
};
</script>
